let IdNamePair = require('./IdNamePair');

module.exports = class Publisher extends IdNamePair {};
